<div *ngIf="!drillDownDataStatus" class="card dashboardTable container-DNF">
    {{ "DATA_NOT_FOUND" | translate }}
</div>
<div *ngIf="drillDownDataStatus" class="card dashboardTable container-table">
    <!-- <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button>
            <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
        </ng-template>
        <ng-template pTemplate="right" class="parent_dialog">
            <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload>
            <button (click)="menu_dialog.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                icon="pi pi-upload" class="p-button-help"></button>

            <button type="button" pButton pRipple icon="pi pi-file" (click)="menu_dialog.toggle($event)" class="mr-2" pTooltip="Download" tooltipPosition="bottom"></button>

            <p-menu styleClass="prime-slider-override" class="child_dialog" #menu_dialog [popup]="true"
                [model]="appVerificationItems_dialog"></p-menu>
        </ng-template>

    </p-toolbar> -->
    <p-table #miSurvey [value]="drillDownData" [scrollable]="true" scrollHeight="flex" [rows]="10"
        [paginator]="true" [globalFilterFields]="[
    'appId',
    'NextActionToBeTaken',
    'District',
    'PendingDays', 
    'UserId',
    'pendingAtUser', 
    'action_Date',
    'UserName',
    'mobile'
    ]" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <button type="button" pButton pRipple icon="pi pi-file" label="{{'DOWNLOAD'| translate}}" (click)="menu_dialog.toggle($event)" class="mr-2" pTooltip="" tooltipPosition="bottom"></button>

                    <p-menu styleClass="prime-slider-override" class="child_dialog" #menu_dialog [popup]="true"
                        [model]="appVerificationItems_dialog"></p-menu>
                </span>
                <span class="p-input-icon-right">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'VIEW_APPLICATION' | translate }}</th>
                <th pSortableColumn="appId">{{'APPLICATION_ID'| translate}}
                    <p-columnFilter type="text" field="appId" display="menu"></p-columnFilter>
                    <p-sortIcon field="appId"></p-sortIcon>
                </th>
                <th pSortableColumn="NextActionToBeTaken">{{'NEXT_ACTION_TO_BE_TAKEN'| translate}}
                    <p-columnFilter type="text" field="NextActionToBeTaken" display="menu"></p-columnFilter>
                    <p-sortIcon field="NextActionToBeTaken"></p-sortIcon>
                </th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="PendingDays">{{'PENDING_DAYS'| translate}}
                    <p-columnFilter type="text" field="PendingDays" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingDays"></p-sortIcon>
                </th>
                <th pSortableColumn="UserId">{{'USER_ID'| translate}}
                    <p-columnFilter type="text" field="UserId" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserId"></p-sortIcon>
                </th>
                <th pSortableColumn="pendingAtUser">{{'PENDING_AT'| translate}}
                    <p-columnFilter type="text" field="pendingAtUser" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingAtUser"></p-sortIcon>
                </th>
                <th pSortableColumn="action_Date">{{'ACTION_DATE'| translate}}
                    <p-columnFilter type="text" field="action_Date" display="menu"></p-columnFilter>
                    <p-sortIcon field="action_Date"></p-sortIcon>
                </th>
                <th pSortableColumn="UserName">{{'USER_NAME'| translate}}
                    <p-columnFilter type="text" field="UserName" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserName"></p-sortIcon>
                </th>
                <th pSortableColumn="mobile">{{'MOBILE'| translate}}
                    <p-columnFilter type="text" field="mobile" display="menu"></p-columnFilter>
                    <p-sortIcon field="mobile"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <p-progressSpinner *ngIf="!drillDownData"></p-progressSpinner>
        <ng-template pTemplate="body" let-drillDownData>
            <tr>
                <td>
                    <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                        class="p-button-rounded p-button-accent mr-1 btnSize"
                        (click)="selectFarmerApplication(drillDownData)"></button>
                </td>
                <td>{{drillDownData?.appId}}</td>
                <td>{{drillDownData?.NextActionToBeTaken}}</td>
                <td>{{drillDownData?.District}}</td>
                <td>{{drillDownData?.PendingDays}}</td>
                <td>{{drillDownData?.UserId}}</td>
                <td>{{drillDownData?.pendingAtUser}}</td>
                <td>{{drillDownData?.action_Date | date:"medium"}}</td>
                <td>{{drillDownData?.UserName}}</td>
                <td>{{drillDownData?.mobile}}</td>
            </tr>
        </ng-template>

    </p-table>
</div>